import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../utils/moneyUtils';

/**
 * MoneyDisplay - Component for displaying currency values with consistent formatting
 *
 * Features:
 * - Always shows commas for thousands separators
 * - Displays exactly 2 decimal places
 * - Handles negative values with -$ prefix
 * - Optional currency symbol ($)
 * - Handles null/undefined/zero values gracefully
 *
 * @component
 * @example
 * <MoneyDisplay value={1234.56} /> // Output: $1,234.56
 * <MoneyDisplay value={-1234.56} /> // Output: -$1,234.56
 * <MoneyDisplay value={1234.56} showCurrency={false} /> // Output: 1,234.56
 */
const MoneyDisplay = ({ value, showCurrency = true, className = '' }) => {
  // Handle null/undefined
  const displayValue = value ?? 0;

  // Format the value
  const formattedValue = showCurrency
    ? formatCurrency(displayValue)
    : displayValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

  return (
    <span className={className}>
      {formattedValue}
    </span>
  );
};

MoneyDisplay.propTypes = {
  value: PropTypes.number,
  showCurrency: PropTypes.bool,
  className: PropTypes.string
};

export default MoneyDisplay;
